export const folderTypes: EnrolmentMailFolderTypes = {
    main: 0,
    spam: 1,
    deleted: 2,
    draft: 3,
    sent: 4,
};

export const mailSendTypes: EnrolmentMailSendTypes = {
    new: 0,
    reply: 1,
    replyAll: 2,
    forward: 3,
};

export const mailTypes: EnrolmentMailTypes = {
    received: 0,
    sent: 1,
    draft: 2,
};

export const folderOptions: { [key: number]: EnrolmentMailListTypes } = {
    // Main Folder
    [folderTypes.main]: {
        typeColumn: false,
        selectColumn: true,
        lastActionColumn: true,
        fromColumn: true,
        toColumn: false,
        readColumn: true,

        replyButton: true,
        assignButton: true,
        createApplicationButton: true,

        editButton: false,
        deleteButton: false,
        forwardButton: false,

        showMoreOptions: true,
        replyAllOptionsButton: true,
        forwardOptionsButton: true,
        assignOptionsButton: false,
        moveToSentOptionsButton: false,
        moveToSpamOptionsButton: true,
        moveToInboxOptionsButton: false,
        moveToDeletedOptionsButton: true,
        unassignOptionsButton: true,
    },
    // Spam Folder
    [folderTypes.spam]: {
        typeColumn: false,
        selectColumn: true,
        lastActionColumn: true,
        fromColumn: true,
        toColumn: false,
        readColumn: true,

        replyButton: true,
        assignButton: true,
        createApplicationButton: true,

        editButton: false,
        deleteButton: false,
        forwardButton: false,

        showMoreOptions: true,
        replyAllOptionsButton: true,
        forwardOptionsButton: true,
        assignOptionsButton: false,
        moveToSentOptionsButton: false,
        moveToSpamOptionsButton: false,
        moveToInboxOptionsButton: true,
        moveToDeletedOptionsButton: true,
        unassignOptionsButton: false,
    },
    // Deleted Folder
    [folderTypes.deleted]: {
        typeColumn: true,
        selectColumn: true,
        lastActionColumn: true,
        fromColumn: true,
        toColumn: false,
        readColumn: true,

        replyButton: true,
        assignButton: true,
        createApplicationButton: true,

        editButton: false,
        deleteButton: false,
        forwardButton: false,

        showMoreOptions: true,
        replyAllOptionsButton: true,
        forwardOptionsButton: true,
        assignOptionsButton: false,
        moveToSentOptionsButton: true,
        moveToSpamOptionsButton: true,
        moveToInboxOptionsButton: true,
        moveToDeletedOptionsButton: false,
        unassignOptionsButton: false,
    },
    // Draft Folder
    [folderTypes.draft]: {
        typeColumn: false,
        selectColumn: true,
        lastActionColumn: false,
        fromColumn: true,
        toColumn: true,
        readColumn: false,

        replyButton: false,
        assignButton: false,
        createApplicationButton: false,

        editButton: true,
        deleteButton: true,
        forwardButton: false,

        showMoreOptions: false,
        replyAllOptionsButton: false,
        forwardOptionsButton: false,
        assignOptionsButton: false,
        moveToSentOptionsButton: false,
        moveToSpamOptionsButton: false,
        moveToInboxOptionsButton: false,
        moveToDeletedOptionsButton: false,
        unassignOptionsButton: false,
    },
    // Sent Folder
    [folderTypes.sent]: {
        typeColumn: false,
        selectColumn: false,
        lastActionColumn: true,
        fromColumn: false,
        toColumn: true,
        readColumn: false,

        replyButton: false,
        assignButton: true,
        createApplicationButton: false,

        editButton: false,
        deleteButton: false,
        forwardButton: false,

        showMoreOptions: true,
        replyAllOptionsButton: false,
        forwardOptionsButton: true,
        assignOptionsButton: true,
        moveToSentOptionsButton: false,
        moveToSpamOptionsButton: false,
        moveToInboxOptionsButton: false,
        moveToDeletedOptionsButton: true,
        unassignOptionsButton: true,
    },
};